import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/printing-fiscal',
    name: RouteName.SettingsPrintingFiscal,
    component: () => import('@/pages/Settings/PrintingFiscal.vue'),
    meta: {
      permissions: [CRMPermission.PrintingFiscal],
      breadcrumb: {
        label: 'Печать и фискализация',
        parent: RouteName.Settings,
      },
    },
  },
]
